import { Chip, Tooltip } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IPartFinderCatalogFamily } from 'partFinder/types';
import { Size } from 'theme/enums';

// The first manufacturer, then "+N" holding the rest in its tooltip. A group row has no family
// behind it: its value is the group's name, the manufacturers the grouped families share.
export const ManufacturersCell = ({
  data,
  value,
}: ICellRendererParams<IPartFinderCatalogFamily>) => {
  if (!data) {
    return <>{value ?? ''}</>;
  }

  const names = data.manufacturers?.map(({ name }) => name) ?? [];

  if (names.length <= 1) {
    return <>{names[0] ?? ''}</>;
  }

  return (
    <>
      {names[0]}{' '}
      <Tooltip title={names.slice(1).join(', ')}>
        <Chip size={Size.SM}>{`+${names.length - 1}`}</Chip>
      </Tooltip>
    </>
  );
};
